<ng-template #content let-modal>
    <app-pdf-viewer [fileName]="fileName" [fullScreen]="true" (close)="onClose()" (export)="onExport()" [src]="fileUrl"></app-pdf-viewer>
</ng-template>